import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "hints-viewer__container" }
const _hoisted_2 = { class: "hints-viewer__container__header" }
const _hoisted_3 = { class: "hints-viewer__container__header__left" }
const _hoisted_4 = { class: "hints-viewer__container__header__right" }
const _hoisted_5 = { class: "hints-viewer__container__content" }
const _hoisted_6 = { class: "hints-viewer__slider__image" }
const _hoisted_7 = ["src"]

import StoryPopup from "@/components/Home/Content/Story/StoryPopup.vue";
import {nextTick, onMounted, onUnmounted, ref} from "vue";
import HintsViewer from "@/ts/User/HintsViewer";
import CloseButton from "@/components/UI/Button/CloseButton.vue";
import Icon from "@/components/UI/Icon.vue";
import 'swiper/css';
import 'swiper/css/pagination';
import {Swiper, SwiperSlide} from "swiper/vue";
import {Pagination} from 'swiper/modules';
import type {PaginationOptions} from "swiper/types";
import HintRepository from "@/ts/User/Repository/HintRepository";
import CDN from "@/ts/Utility/CDN";


export default /*@__PURE__*/_defineComponent({
  __name: 'HintsViewer',
  setup(__props) {

const container = ref<HTMLDivElement>()
const popup = ref<StoryPopup>()

const showedPopup = ref(false)
let viewer: HintsViewer;
const slides = ref<string[]>([])

const loadSlides = async () => {
  slides.value = (await HintRepository.getAll()).map(hint => hint.image)
}

onMounted(() => {
  const viewer = HintsViewer.getInstance()
  viewer.addOnShowListener(async () => {
    loadSlides().then()
    container.value!.classList.add('active')
    showedPopup.value = false
    await nextTick()
    showedPopup.value = true
  })
  viewer.init(container.value!)
})
const onClose = () => {
  setTimeout(() => {
    showedPopup.value = false
  }, 500)
}
onUnmounted(() => {
  showedPopup.value = false
  viewer?.destroy()
})
const modules = [Pagination]
const pagination: PaginationOptions = {
  el: '.hints-viewer__container__footer',
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "container",
    ref: container,
    class: "hints-viewer"
  }, [
    (showedPopup.value)
      ? (_openBlock(), _createBlock(StoryPopup, {
          key: 0,
          ref_key: "popup",
          ref: popup,
          onClose: onClose,
          activeUntilOffset: 100
        }, {
          default: _withCtx(({hide}) => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(Icon, {
                    name: "zipper",
                    color: "#FD9F30",
                    size: 14
                  }),
                  _cache[0] || (_cache[0] = _createTextVNode(" Подсказки "))
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(CloseButton, {
                    theme: "dark",
                    onClick: hide
                  }, null, 8, ["onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(Swiper), {
                  pagination: pagination,
                  spaceBetween: 20,
                  modules: modules,
                  class: "hints-viewer__slider__swiper"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slides.value, (slide) => {
                      return (_openBlock(), _createBlock(_unref(SwiperSlide), null, {
                        default: _withCtx(() => [
                          _createElementVNode("picture", _hoisted_6, [
                            _createElementVNode("img", {
                              src: _unref(CDN).createUrl(slide)
                            }, null, 8, _hoisted_7)
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 256))
                  ]),
                  _: 1
                })
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "hints-viewer__container__footer" }, null, -1))
            ])
          ]),
          _: 1
        }, 512))
      : _createCommentVNode("", true)
  ], 512))
}
}

})